export default {
  menuItems: getState("menu")
};

function getState(key) {
  return JSON.parse(window.localStorage.getItem(key));
}
